import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface DeleteCustomerAddressMutationObject {
  mutation: {
    deleteCustomerAddress: {
      __args: {
        id: number
      }
    }
  }
}

export const deleteCustomerAddressMutationObject: DeleteCustomerAddressMutationObject = {
  mutation: {
    deleteCustomerAddress: {
      __args: {
        id: 0
      }
    }
  }
}

interface DeleteCustomerAddressMutationInput {
  id: number
}

export type DeleteCustomerAddressMutation = (input: DeleteCustomerAddressMutationInput) => Promise<FetchResult<any>>

export const createDeleteCustomerAddressMutation = ({ getMutations }: ServiceDependencies): DeleteCustomerAddressMutation => async ({ id }) => {
  const mutation = getMutations().deleteCustomerAddressMutation
  mutation.mutation.deleteCustomerAddress.__args.id = id

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
